import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500/15 text-primary-500">
        <i className="ri-film-line text-[36px]" aria-hidden="true"></i>
      </span>
      <h1 className="mt-5 font-heading text-3xl font-700 tracking-wide text-foreground-950 md:text-4xl">
        页面走丢了
      </h1>
      <p className="mt-2 font-mono text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        这个页面可能已被移除或从未存在过，返回首页继续浏览最新影视资讯吧。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/category"
          className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-500 text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-500"
        >
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}